import {message} from "antd";
import {getDataList, getProgramList, deleteProgram} from '../services/statisticalExport';

// 设置加载属性
const setSpinProps = ({put, spinning = false, tip = ''}) => {
  return put({
    type: 'save',
    payload: {
      spinProps: {
        spinning,
        tip,
      },
    },
  });
};

const initState = () => {
  return {
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    programList: [], // 应用列表
    programId: null, // 已选应用id
    status: '', // 已选应用状态
    tableData: {titlesList: [], valuesList: []}, // 列表数据
    pageInfo: {
      page: 1,
      pageSize: 10,
    }, // 分页信息
    selectedRowKeys: [], // 已选行id列表
    selectedTitleKeys: [], // 已选表头列表
    selectedTitleAll: false, //
  };
};

export default {
  namespace: 'statisticalExport',

  state: initState(),

  subscriptions: {
    setup({dispatch, history}) {
      history.listen(({pathname, query}) => {
        if (pathname.match(/\/statisticalExport$/)) {

          const {flowCode, programCode} = query;

          dispatch({
            type: 'fetchList',
            payload: {
              getProgram: true,
              programCode: flowCode || programCode,
              ...initState().pageInfo,
            },
          });
        }
      });
    },
  },

  effects: {
    * fetchList({payload}, {call, put, select}) {
      try {
        yield setSpinProps({put, spinning: true, tip: '加载中...'});

        const {getProgram, ...searchParams} = payload || {};

        if (getProgram) {
          const programList = yield call(getProgramList, searchParams);
          yield put({
            type: 'save',
            payload: {
              programList,
              programId: programList && programList.length && programList[0].programId || null,
            },
          });
        }

        const {programId, status, pageInfo: oldPageInfo} = yield select(({statisticalExport}) => statisticalExport);

        if (!programId) {
          message.warning('未查询到流程应用信息');
          yield setSpinProps({put});
          return;
        }

        const {content, ...pageInfo} = yield call(getDataList, {
          programId,
          status,
          ...oldPageInfo,
          ...searchParams,
        });

        const {titlesList, valuesList} = content || {};

        yield put({
          type: 'save',
          payload: {
            programId: searchParams.programId || programId,
            status: searchParams.status || status,
            tableData: {
              titlesList,
              valuesList: valuesList.map((valueItem) => {
                const valueData = {};
                valueItem.forEach(({id, value}) => {
                  valueData[id] = value || '-';
                });
                return valueData;
              })
            },
            pageInfo: {
              ...oldPageInfo,
              ...pageInfo
            },
            spinProps: {
              spinning: false,
            },
            selectedRowKeys: [],
            selectedTitleKeys: titlesList.map(({id}) => id), // 默认表头数据全选
            selectedTitleAll: true, // 默认表头数据全选
          },
        });
      } catch (error) {
        yield setSpinProps({put});
      }
    },

    // 删除表单数据
    * fetchTableDelete({payload}, {call, put}) {
      try {
        yield setSpinProps({put, spinning: true, tip: '删除中...'});

        yield call(deleteProgram, payload);

        message.success('删除成功');

        yield setSpinProps({put});

        yield put({type: 'fetchList'});

      } catch (error) {
        yield setSpinProps({put});
      }
    },
  },

  reducers: {
    save(state, {payload}) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {...initState()};
    },
    showCopyModal(state, {payload}) {
      return {
        ...state,
        ...payload,
        copyModalVisible: true,
      };
    },
    hideCopyModal(state, {payload}) {
      return {
        ...state,
        ...payload,
        copyModalKey: Date.now(),
        copyModalVisible: false,
        copyTemplateOrgId: '',
        programId: null
      };
    },
  },
};
